import Head from 'next/head';
import PlainBanner from '../../components/common/PlainBanner';
import React, { Fragment, useState } from 'react';
import { GetMediaData } from '../../api/media'
import News from '../../components/media/News';
import InfiniteScroll from '../../components/common/InfiniteScroll';
import Config from '../../config';
import { useRouter } from 'next/router';
import { getStaticPath } from '../../utils';
import { getPageViewData } from '../../utils/tracking';
import { trackPage } from '../../tracking';


export async function getServerSideProps() {
  return {
    props: { pageName: 'media' }
  }
}

export default function Home() {
  const [posts, setPosts] = useState<any[]>([])
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(5);
  const hasMoreData = posts.length < total;
  const loadMoreNews = () => {
    if (hasMoreData) {
      setLoading(true);
      GetMediaData({ page: page, application: 'website' })
        .then((response) => {
          if (response) {
            if (response.data.status) {
              setPosts([...posts, ...response.data.news]);
              setTotal(response.data.total);
            }
            setLoading(false);
          }
        })
      setPage(page + 1);
    }
  };

  const router  = useRouter()
  const BASE_URL = Config.BASE_URL
  const OG_IMAGE = getStaticPath("/static/images/why-onsitego.svg")

  React.useEffect(()=>{
    trackPage('Media',{...getPageViewData()})
  },[])

  return (
    <Fragment>
      <Head>
        <title>Exciting News and Media Coverage | Onsitego</title>
        <link rel="icon" href="/favicon.ico" />
        <meta name="description" content={"Check out our media page for the latest news, videos, stories and all coverage."}></meta>
        <meta property="og:title" content={"Exciting News and Media Coverage | Onsitego"}/>
        <meta property="og:description" content={"Check out our media page for the latest news, videos, stories and all coverage."}/>
        <meta property="og:url" content={`${BASE_URL}${router.asPath}`}/>
        <meta property="og:image" content={OG_IMAGE}/>
        <link rel="canonical" href={`${BASE_URL}${router.asPath}`}></link>

      </Head>
      <PlainBanner className="contact-us" title="Media Coverage - Onsitego" subtitle="" />
      <div className="news">
        <InfiniteScroll
          hasMoreData={hasMoreData}
          isLoading={loading}
          onBottomHit={loadMoreNews}
          loadOnMount={true}>
          {
            posts.map((item, index) => (
              <div id={`post-${index}`} key={index}>
                <News  {...item} key={index} id={index} />
              </div>
            ))
          }
        </InfiniteScroll>
      </div>
    </Fragment>
  )
}
